import { render, staticRenderFns } from "./RecruiterCompanyIndustry.vue?vue&type=template&id=1132ef57&scoped=true"
import script from "./RecruiterCompanyIndustry.vue?vue&type=script&lang=ts"
export * from "./RecruiterCompanyIndustry.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterCompanyIndustry.vue?vue&type=style&index=0&id=1132ef57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1132ef57",
  null
  
)

export default component.exports